import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { Box, Grid } from '@mui/material';
import React from 'react';
import { Heading, Text } from '../atomic';
import GreenCornerBox from '../ui/GreenCornerBox';

/**
 * Why Collaborate section highlighting benefits of working with RSM Collective
 *
 * @returns {JSX.Element} Why collaborate section component
 */
function WhyCollaborateSection() {
  const whyCollaborate = [
    {
      icon: <LightbulbIcon />,
      title: 'Innovation Excellence',
      description:
        'Access cutting-edge AI and automation technologies for enterprise solutions',
    },
    {
      icon: <PeopleIcon />,
      title: 'Expert Network',
      description:
        'Work with industry-leading consultants and technology specialists',
    },
    {
      icon: <TrendingUpIcon />,
      title: 'Proven Results',
      description:
        'Benefit from our track record of successful enterprise transformations',
    },
    {
      icon: <HealthAndSafetyIcon />,
      title: 'Results-Focused',
      description:
        'Improve business outcomes through technology-enabled solutions',
    },
  ];

  return (
    <Box sx={{ mb: 8 }}>
      <GreenCornerBox>
        <Heading
          variant="h2"
          sx={{ mb: 4, fontSize: '1.75rem', fontWeight: 600 }}
        >
          Why Collaborate with RSM Collective?
        </Heading>
        <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
          {whyCollaborate.map((reason, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <Box sx={{ color: 'primary.main', flexShrink: 0 }}>
                  {React.cloneElement(reason.icon, { sx: { fontSize: 32 } })}
                </Box>
                <Box>
                  <Heading variant="h6" sx={{ mb: 1, fontSize: '1rem' }}>
                    {reason.title}
                  </Heading>
                  <Text
                    sx={{
                      fontSize: '0.9rem',
                      color: '#6c757d',
                      lineHeight: 1.5,
                    }}
                  >
                    {reason.description}
                  </Text>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </GreenCornerBox>
    </Box>
  );
}

export default WhyCollaborateSection;
